<template>
  <div>
    <Page title="退職者一覧">
      <template v-slot:content>
        <div class="uk-card uk-card-default uk-card-body">
          <Table ref="tableComponent" :header="header" :callback="getTableData" @column-click="onColumnClick" />
        </div>
      </template>
    </Page>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import Page from "../molecules/Page.vue";
import Table from "../molecules/Table.vue";
import { EmployeeApi, GetRetiredProfile, StatsItemEnum } from "../../autogen";

@Options({
  components: {
    Page,
    Table
  }
})
export default class Retired extends Vue {
  header = [
    { title: "名前", sortable: true, key: "name", width: 150 },
    { title: "部署", sortable: true, key: "departmentName", width: 150 },
    { title: "職種", key: "occupationName", width: 150 },
    { title: "役職", key: "positionName", width: 150 },
    { title: "最終受検日", key: "lastExamDate", width: 90 },
    { title: "退職日", key: "retirementDate", width: 90 },
    {
      title: "受検結果",
      type: "button",
      key: "result",
      width: 120,
      disabled: (row: GetRetiredProfile) => {
        return !this.appropriateResults || row.lastExamDate === "-";
      }
    }
  ];
  offset?: string;
  appropriateResults: boolean = false;

  async beforeMount() {
    this.appropriateResults = this.$role.isReadable("employeeStats");
  }

  async onColumnClick(location: { row: number; col: string; el: HTMLElement; rowData: GetRetiredProfile }) {
    if (location.col === "result" && location.rowData && location.rowData.department) {
      this.$router.push({
        name: "EmployeeStats",
        params: {
          clientId: this.$route.params["clientId"],
          peopleId: location.rowData.id,
          suffix: "EVENT#retired#",
          statsItems: [
            StatsItemEnum.CulturalFit,
            StatsItemEnum.HumanSkill,
            StatsItemEnum.PersonalityDetail,
            StatsItemEnum.Sociality,
            StatsItemEnum.ActivityMotivationDetail,
            StatsItemEnum.Behavior,
            StatsItemEnum.SelfEvaluation,
            StatsItemEnum.InterviewTips,
            StatsItemEnum.Reliability,
            StatsItemEnum.Judgement,
            StatsItemEnum.JobInterest,
            StatsItemEnum.LastExamDate,
            StatsItemEnum.ExamDate
          ]
        }
      });
    }
  }
  async getTableData() {
    if (this.offset === null) {
      return [];
    }
    const response = await new EmployeeApi().getRetired({
      limit: "100",
      offset: this.offset ? this.offset : undefined
    });
    this.offset = response.data.offset;
    if (!response.data.lists || !response.data.lists.length) return [];
    return response.data.lists.map(datum =>
      Object.assign(datum, {
        name: `${datum.lastName} ${datum.firstName}`,
        departmentName: datum.department || "-",
        occupationName: datum.occupation || "-",
        positionName: datum.position || "-",
        lastExamDate: datum.lastExamDate || "-",
        retirementDate: datum.retirementDate || "-"
      })
    );
  }
}
</script>
